var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-form",
    {
      ref: "elementDetail",
      attrs: {
        model: _vm.element,
        rules: _vm.elementRules,
        "labq-width": "100px",
      },
    },
    [
      _c(
        "q-form-item",
        { attrs: { label: "نوع", prop: "type" } },
        [
          _c("q-input", {
            attrs: { type: "text", placeholder: "" },
            model: {
              value: _vm.element.type,
              callback: function ($$v) {
                _vm.$set(_vm.element, "type", $$v)
              },
              expression: "element.type",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-form-item",
        { attrs: { label: "", prop: "autoGenerate" } },
        [
          _c(
            "q-checkbox",
            {
              attrs: { placeholder: "" },
              model: {
                value: _vm.element.autoGenerate,
                callback: function ($$v) {
                  _vm.$set(_vm.element, "autoGenerate", $$v)
                },
                expression: "element.autoGenerate",
              },
            },
            [_c("span", [_vm._v("تولید شود")])]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-form-item",
        { attrs: { label: "برچسب", prop: "key" } },
        [
          _c("q-input", {
            attrs: { type: "text", placeholder: "" },
            model: {
              value: _vm.element.label,
              callback: function ($$v) {
                _vm.$set(_vm.element, "label", $$v)
              },
              expression: "element.label",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-form-item",
        { attrs: { label: "خصوصیت", prop: "property" } },
        [
          _c("q-input", {
            attrs: { type: "text", placeholder: "" },
            model: {
              value: _vm.element.property,
              callback: function ($$v) {
                _vm.$set(_vm.element, "property", $$v)
              },
              expression: "element.property",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-form-item",
        { attrs: { label: "", prop: "disabled" } },
        [
          _c(
            "q-checkbox",
            {
              attrs: { placeholder: "" },
              model: {
                value: _vm.element.disabled,
                callback: function ($$v) {
                  _vm.$set(_vm.element, "disabled", $$v)
                },
                expression: "element.disabled",
              },
            },
            [_c("span", [_vm._v("فقط خواندنی")])]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-form-item",
        { attrs: { label: "متن کمکی", prop: "note" } },
        [
          _c("q-input", {
            attrs: { type: "textarea", placeholder: "" },
            model: {
              value: _vm.element.note,
              callback: function ($$v) {
                _vm.$set(_vm.element, "note", $$v)
              },
              expression: "element.note",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-form-item",
        { attrs: { label: "متن داخلی", prop: "placeholder" } },
        [
          _c("q-input", {
            attrs: { type: "text", placeholder: "" },
            model: {
              value: _vm.element.placeholder,
              callback: function ($$v) {
                _vm.$set(_vm.element, "placeholder", $$v)
              },
              expression: "element.placeholder",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.element.type === "input"
        ? [
            _c(
              "q-form-item",
              { attrs: { label: "نوع متن", prop: "inputType" } },
              [
                _c("q-input", {
                  attrs: { type: "text", placeholder: "" },
                  model: {
                    value: _vm.element.inputType,
                    callback: function ($$v) {
                      _vm.$set(_vm.element, "inputType", $$v)
                    },
                    expression: "element.inputType",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm.element.type === "checkBox"
        ? void 0
        : _vm.element.type === "colorPicker"
        ? void 0
        : _vm.element.type === "datePicker"
        ? [_vm._v("\n    - contain time\n  ")]
        : _vm.element.type === "itemSelector"
        ? [
            _vm._v("\n    - items\n    "),
            _c(
              "q-form-item",
              { attrs: { label: "نوع انتخاب", prop: "selectorType" } },
              [
                _c("q-input", {
                  attrs: { type: "text", placeholder: "" },
                  model: {
                    value: _vm.element.selectorType,
                    callback: function ($$v) {
                      _vm.$set(_vm.element, "selectorType", $$v)
                    },
                    expression: "element.selectorType",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm.element.type === "modelSelector"
        ? [
            _c(
              "q-form-item",
              { attrs: { label: "نوع انتخاب", prop: "selectorType" } },
              [
                _c("q-input", {
                  attrs: { type: "text", placeholder: "" },
                  model: {
                    value: _vm.element.selectorType,
                    callback: function ($$v) {
                      _vm.$set(_vm.element, "selectorType", $$v)
                    },
                    expression: "element.selectorType",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-form-item",
              { attrs: { label: "سیستم", prop: "plugin" } },
              [
                _c("q-input", {
                  attrs: { type: "text", placeholder: "" },
                  model: {
                    value: _vm.element.plugin,
                    callback: function ($$v) {
                      _vm.$set(_vm.element, "plugin", $$v)
                    },
                    expression: "element.plugin",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-form-item",
              { attrs: { label: "عملیات واکشی", prop: "fetchDelegate" } },
              [
                _c("q-input", {
                  attrs: { type: "text", placeholder: "" },
                  model: {
                    value: _vm.element.fetchDelegate,
                    callback: function ($$v) {
                      _vm.$set(_vm.element, "fetchDelegate", $$v)
                    },
                    expression: "element.fetchDelegate",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-form-item",
              { attrs: { label: "فیلد نمایشی", prop: "displayField" } },
              [
                _c("q-input", {
                  attrs: { type: "text", placeholder: "" },
                  model: {
                    value: _vm.element.displayField,
                    callback: function ($$v) {
                      _vm.$set(_vm.element, "displayField", $$v)
                    },
                    expression: "element.displayField",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-form-item",
              { attrs: { label: "فیلد مقدار", prop: "valueField" } },
              [
                _c("q-input", {
                  attrs: { type: "text", placeholder: "" },
                  model: {
                    value: _vm.element.valueField,
                    callback: function ($$v) {
                      _vm.$set(_vm.element, "valueField", $$v)
                    },
                    expression: "element.valueField",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm.element.type === "parameterSelector"
        ? [
            _c(
              "q-form-item",
              { attrs: { label: "نوع انتخاب", prop: "selectorType" } },
              [
                _c("q-input", {
                  attrs: { type: "text", placeholder: "" },
                  model: {
                    value: _vm.element.selectorType,
                    callback: function ($$v) {
                      _vm.$set(_vm.element, "selectorType", $$v)
                    },
                    expression: "element.selectorType",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-form-item",
              { attrs: { label: "", prop: "multiple" } },
              [
                _c(
                  "q-checkbox",
                  {
                    attrs: { placeholder: "" },
                    model: {
                      value: _vm.element.multiple,
                      callback: function ($$v) {
                        _vm.$set(_vm.element, "multiple", $$v)
                      },
                      expression: "element.multiple",
                    },
                  },
                  [_c("span", [_vm._v("چند انتخابی است")])]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-form-item",
              { attrs: { label: "نام پارامتر", prop: "parameterKey" } },
              [
                _c("q-input", {
                  attrs: { type: "text", placeholder: "" },
                  model: {
                    value: _vm.element.parameterKey,
                    callback: function ($$v) {
                      _vm.$set(_vm.element, "parameterKey", $$v)
                    },
                    expression: "element.parameterKey",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm.element.type === "number"
        ? void 0
        : _vm.element.type === "upload"
        ? [_vm._v("\n    - file types\n  ")]
        : _vm.element.type === "money"
        ? [_vm._v("\n    - currency\n  ")]
        : _vm.element.type === "percentage"
        ? void 0
        : _vm.element.type === "password"
        ? void 0
        : _vm.element.type === "monthPicker"
        ? void 0
        : _vm.element.type === "label"
        ? void 0
        : _vm.element.type === "compositeList"
        ? [
            _c(
              "q-form-item",
              { attrs: { label: "نام ساختار لیست", prop: "structureKey" } },
              [
                _c("q-input", {
                  attrs: { type: "text", placeholder: "" },
                  model: {
                    value: _vm.element.structureKey,
                    callback: function ($$v) {
                      _vm.$set(_vm.element, "structureKey", $$v)
                    },
                    expression: "element.structureKey",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm.element.type === "audience"
        ? void 0
        : _vm.element.type === "dateRange"
        ? [_vm._v("\n    - start time\n    - end time\n  ")]
        : _vm.element.type === "numberRange"
        ? [_vm._v("\n    - min\n    - max\n  ")]
        : _vm.element.type === "moneyRange"
        ? [_vm._v("\n    - currency\n    - min\n    - max\n  ")]
        : _vm.element.type === "compositeDetail"
        ? [
            _c(
              "q-form-item",
              { attrs: { label: "نام فرم", prop: "formStructureKey" } },
              [
                _c("q-input", {
                  attrs: { type: "text", placeholder: "" },
                  model: {
                    value: _vm.element.formStructureKey,
                    callback: function ($$v) {
                      _vm.$set(_vm.element, "formStructureKey", $$v)
                    },
                    expression: "element.formStructureKey",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }